<vwui-modal-header>
    <h3>Teamlid {{action}}</h3>
</vwui-modal-header>

<vwui-modal-body [formGroup]="form">
    <vwui-form-group label="Naam">
        <vwui-input formControlName="name" placeholder="Voer een naam in"></vwui-input>
    </vwui-form-group>
    <vwui-form-group label="Rol">
        <ng-select [items]="roles" formControlName="role" placeholder="Kies een rol" appendTo="body" ></ng-select>
    </vwui-form-group>
</vwui-modal-body>

<vwui-modal-footer>
    <vwui-button class="is-light" (click)="modalRef.close()">Annuleren</vwui-button>
    <vwui-button class="is-primary" (click)="saveTeamMember()" [disabled]="form.invalid || saving">Opslaan</vwui-button>
</vwui-modal-footer>
